
interface ReferenceIdProps {
  children: string;
}

const ReferenceId = ({ children }: ReferenceIdProps) => {
  return (
    <div className="text-xs text-muted-foreground mt-2 font-mono">{children}</div>
  );
};

export default ReferenceId;
